import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, Users, Heart, Clock, Award, ArrowRight, MapPin, Phone, Mail, MessageCircle, Send } from 'lucide-react';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MailingListSection from '../components/MailingListSection';
import SEO from '../components/SEO';
import { ScrollReveal } from '../components/ScrollReveal';
import './HomePageNew.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePageNew = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [featuredProjects, setFeaturedProjects] = useState([]);
  
  // Contact form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [formStatus, setFormStatus] = useState({ loading: false, success: false, error: null });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!privacyAccepted) {
      setFormStatus({ loading: false, success: false, error: 'Por favor, aceite a Política de Privacidade.' });
      return;
    }
    setFormStatus({ loading: true, success: false, error: null });

    try {
      await axios.post(`${API}/submissions/contact`, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message
      });
      
      setFormStatus({ loading: false, success: true, error: null });
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setPrivacyAccepted(false);
      
      setTimeout(() => {
        setFormStatus(prev => ({ ...prev, success: false }));
      }, 5000);
    } catch (error) {
      setFormStatus({ loading: false, success: false, error: 'Ocorreu um erro ao enviar a mensagem.' });
    }
  };

  const heroSlides = [
    {
      image: 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/v4nxsceg_act.jpg',
      title: 'Promover',
      subtitle: 'a Saúde Mental',
      highlight: 'na Comunidade'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/79r82hb9_0A07676F-6488-4A8C-AB06-A72C57D78A73_1_105_c%20%282%29.jpeg',
      title: 'Apoiar',
      subtitle: 'Pessoas',
      highlight: 'com Dignidade'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/a60ydro9_WhatsApp%20Image%202026-02-18%20at%2017.01.36%20%281%29.jpeg',
      title: 'Construir',
      subtitle: 'Futuros',
      highlight: 'com Esperança'
    }
  ];

  const services = [
    {
      image: 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/3e1xw7ba_WhatsApp%20Image%202026-02-18%20at%2019.03.33.jpeg',
      title: 'INTERVENÇÃO',
      description: 'Reabilitação psicossocial, apoio psicológico e apoio social.',
      link: '/intervencao'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/610wv1ys_473926587_626215926633826_2090677860086780026_n.jpg',
      title: 'PROJETOS',
      description: 'Iniciativas que promovem a inclusão social e o desenvolvimento comunitário.',
      link: '/projetos'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/z5vy7oa0_transferir%20%283%29.jfif',
      title: 'INSTITUCIONAL',
      description: 'Conheça a nossa história.',
      link: '/institucional'
    }
  ];

  const stats = [
    { icon: Clock, value: '37+', label: 'Anos de Experiência' },
    { icon: Users, value: '500+', label: 'Pessoas Apoiadas' },
    { icon: Heart, value: '10+', label: 'Projetos Ativos' },
    { icon: Award, value: '100%', label: 'Dedicação' }
  ];

  const projects = [
    {
      image: 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/h14i1ail_WhatsApp%20Image%202025-12-15%20at%2016.21.46.jpeg',
      title: 'Elos & Elas',
      description: 'Promoção da inclusão social e fortalecimento da coesão comunitária nos territórios da Ajuda',
      slug: 'elos-elas'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_76c76c76-e4ba-4b08-81e5-aee0de7c1d36/artifacts/tep6mxes_1D929A9F-CF9C-4573-B03B-7E71A7BE8AD0_1_105_c.jpeg',
      title: 'Feira de Saúde e Bem Estar',
      description: 'Promoção da saúde e bem-estar através de atividades comunitárias e sensibilização',
      slug: 'feira-saude'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_36d29fb2-421d-4d4a-b3e0-267c34f8e343/artifacts/pljxu5oc_266833491_4572124216199569_405896564858312453_n.jpg',
      title: 'TIS - Teatro de Inclusão Social',
      description: 'Arte, Saúde mental e Inclusão em Teatro de Comunidade.',
      slug: 'tis'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_76c76c76-e4ba-4b08-81e5-aee0de7c1d36/artifacts/sq8in7e9_WhatsApp%20Image%202026-02-25%20at%2014.11.30.jpeg',
      title: 'Podcast: A falar é que a gente se entende',
      description: 'Conversas sobre saúde mental, inclusão social, cidadania e bem-estar',
      slug: 'hora-empatia'
    }
  ];

  // Load featured projects dynamically from backoffice (CMS)
  useEffect(() => {
    const loadFeatured = async () => {
      try {
        const res = await axios.get(`${API}/cms/public/projects-featured`);
        if (res.data && res.data.length > 0) {
          setFeaturedProjects(res.data.map(p => ({
            image: p.image,
            title: p.title,
            description: p.hero_description,
            slug: p.slug
          })));
        }
      } catch (e) {
        // Keep fallback hardcoded projects on error
      }
    };
    loadFeatured();
  }, []);

  // Use featured from CMS if available, else fallback hardcoded list
  const displayProjects = featuredProjects.length > 0 ? featuredProjects : projects;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  const scrollToContent = () => {
    document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="home-new" data-testid="home-page">
      <SEO 
        title="Início"
        description="A AASPS promove a saúde mental na comunidade através de serviços de reabilitação psicossocial, apoio psicológico e projetos de inclusão social em Barcelos."
        keywords="saúde mental, AASPS, Barcelos, apoio psicológico, reabilitação psicossocial, inclusão social"
        url="/"
      />
      <Header />

      {/* Hero Section - Fullscreen */}
      <section className="hero-velcome" data-testid="hero-section">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`hero-bg ${index === currentSlide ? 'active' : ''} ${index === 1 ? 'slide-position-bottom' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}
        <div className="hero-overlay-velcome" />
        
        <div className="hero-content-velcome">
          <div className="hero-text-velcome active">
            <h1>
              <span className="hero-line">{heroSlides[currentSlide].title}</span>
              <span className="hero-line hero-italic">{heroSlides[currentSlide].subtitle}</span>
              <span className="hero-line hero-highlight">{heroSlides[currentSlide].highlight}</span>
            </h1>
          </div>
          
          <button className="hero-cta-velcome-outline" onClick={() => navigate('/donativos')} data-testid="hero-apoie-nos">
            APOIE-NOS
          </button>
        </div>

        <div className="hero-indicators-velcome">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>

        <div className="scroll-indicator-velcome" onClick={scrollToContent}>
          <span>SCROLL</span>
          <ChevronDown size={20} />
        </div>
      </section>

      {/* Services Section - 3 Cards */}
      <section id="services-section" className="services-velcome">
        <ScrollReveal animation="fade-up">
          <div className="services-intro">
            <h2>Promovemos respostas de qualidade com rigor, dedicação e profissionalismo.</h2>
            <p>Conheça o nosso trabalho e descubra como podemos ajudar.</p>
          </div>
        </ScrollReveal>
        
        <div className="services-grid-velcome">
          {services.map((service, index) => (
            <ScrollReveal key={index} animation="fade-up" delay={index * 150}>
              <div 
                className="service-card-velcome"
                onClick={() => navigate(service.link)}
              >
                <div className="service-image-velcome">
                  <img src={service.image} alt={service.title} />
                  <div className="service-overlay-velcome">
                    <h3>{service.title}</h3>
                    <ChevronDown size={24} className="service-arrow" />
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-velcome">
        <div className="stats-container">
          <ScrollReveal animation="fade-up">
            <h2>O nosso compromisso com a comunidade</h2>
            <p>Promovemos respostas que fortalecem o bem-estar, a inclusão e a autonomia.</p>
          </ScrollReveal>
          
          <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
            {stats.map((stat, index) => (
              <ScrollReveal key={index} animation="scale-up" delay={index * 100}>
                <div className="stat-item">
                  <stat.icon size={32} className="stat-icon" />
                  <span className="stat-value">{stat.value}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="projects-velcome">
        <ScrollReveal animation="fade-up">
          <div className="projects-header">
            <h2>Projetos em Destaque</h2>
            <button className="view-all-btn" onClick={() => navigate('/projetos')}>
              Ver Todos <ArrowRight size={18} />
            </button>
          </div>
        </ScrollReveal>
        
        <div className="projects-grid-velcome">
          {displayProjects.map((project, index) => (
            <ScrollReveal key={index} animation="fade-up" delay={index * 100}>
              <div 
                className="project-card-velcome"
                onClick={() => navigate(`/projetos?projeto=${project.slug}`)}
              >
                <div className={`project-image-velcome ${project.slug === 'hora-empatia' ? 'podcast-img' : ''}`}>
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="project-info-velcome">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-velcome">
        <div className="contact-container-velcome">
          <ScrollReveal animation="fade-right">
            <div className="contact-info-velcome">
              <div className="contact-header-velcome">
                <h2>Fale Connosco</h2>
                <p>Entre em contacto connosco através dos canais abaixo ou preencha o formulário.</p>
              </div>
              
              <div className="contact-details-velcome">
                <div className="contact-item-velcome">
                  <div className="contact-icon-velcome">
                    <MapPin size={20} />
                  </div>
                  <div className="contact-text-velcome">
                    <span className="contact-label">Localização</span>
                    <span className="contact-value">Rua do Cruzeiro, 194 B<br />1300-172 Lisboa</span>
                  </div>
                </div>
                <div className="contact-item-velcome">
                  <div className="contact-icon-velcome">
                    <Phone size={20} />
                  </div>
                  <div className="contact-text-velcome">
                    <span className="contact-label">Telefone</span>
                    <a href="tel:+351213630884" className="contact-value">+351 213 630 884</a>
                  </div>
                </div>
                <div className="contact-item-velcome">
                  <div className="contact-icon-velcome">
                    <Mail size={20} />
                  </div>
                  <div className="contact-text-velcome">
                    <span className="contact-label">E-mail</span>
                    <a href="mailto:geral@aasps.pt" className="contact-value">geral@aasps.pt</a>
                  </div>
                </div>
                <div className="contact-item-velcome">
                  <div className="contact-icon-velcome">
                    <MessageCircle size={20} />
                  </div>
                  <div className="contact-text-velcome">
                    <span className="contact-label">Horário</span>
                    <span className="contact-value">Segunda a Sexta<br />09h00 - 17h00</span>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>
          
          <ScrollReveal animation="fade-left" delay={200}>
            <div className="contact-form-velcome">
              {formStatus.success ? (
                <div className="form-success-home">
                  <Send size={28} />
                  <h3>Mensagem Enviada!</h3>
                  <p>Obrigado pelo seu contacto. Responderemos brevemente.</p>
                </div>
              ) : (
                <form onSubmit={handleFormSubmit} data-testid="home-contact-form">
                  <div className="form-row-home">
                    <div className="form-field-home">
                      <label>NOME *</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Nome completo"
                        value={formData.name}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                    <div className="form-field-home">
                      <label>E-MAIL *</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="exemplo@email.com"
                        value={formData.email}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="form-row-home">
                    <div className="form-field-home">
                      <label>TELEFONE *</label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+351"
                        value={formData.phone}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                    <div className="form-field-home">
                      <label>ASSUNTO *</label>
                      <input
                        type="text"
                        name="subject"
                        placeholder="Assunto da mensagem"
                        value={formData.subject}
                        onChange={handleFormChange}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="form-field-home full-width">
                    <label>MENSAGEM</label>
                    <textarea
                      name="message"
                      placeholder="Descreva o serviço que necessita..."
                      rows={4}
                      value={formData.message}
                      onChange={handleFormChange}
                    />
                  </div>
                  
                  <div className="privacy-checkbox-home">
                    <input
                      type="checkbox"
                      id="privacy-home"
                      checked={privacyAccepted}
                      onChange={(e) => setPrivacyAccepted(e.target.checked)}
                    />
                    <label htmlFor="privacy-home">
                      Li e aceito a <a href="/politica-privacidade">Política de Privacidade</a>
                    </label>
                  </div>
                  
                  {formStatus.error && (
                    <div className="form-error-home">{formStatus.error}</div>
                  )}
                  
                  <button type="submit" className="submit-btn-home" disabled={formStatus.loading}>
                    {formStatus.loading ? 'A ENVIAR...' : (
                      <>
                        ENVIAR MENSAGEM
                        <ArrowRight size={18} />
                      </>
                    )}
                  </button>
                </form>
              )}
            </div>
          </ScrollReveal>
        </div>
      </section>

      <MailingListSection />

      <Footer />
    </div>
  );
};

export default HomePageNew;
